var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronBoldBackwardRtl = function SvgChevronBoldBackwardRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M36.232 86.75a4.217 4.217 0 0 1-5.99.004 4.28 4.28 0 0 1-.065-5.962l.061-.063L60.78 49.954 30.302 19.273a4.28 4.28 0 0 1-.06-5.963l.061-.063a4.216 4.216 0 0 1 5.927-.06l.062.062L69.76 46.94a4.28 4.28 0 0 1 .063 5.96l-.061.063z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronBoldBackwardRtl;